import classNames from "classnames";
import { NextSeo } from "next-seo";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Link from "../components/Link";
import { useStoryblok } from "../lib/storyblok";
import { centraPostWithAuthAndCache } from "../lib/centra-api";
import {
  getStoryblokDataSources,
  getStoryblokStory,
} from "../lib/storyblok-api";
import StoryblokImage from "../components/StoryblokImage";
import { StoryProvider } from "./[...slug]";

export default function Projects({ story: storyProp, ...props }) {
  const story = useStoryblok(storyProp, true);

  let ogImage = "";
  if (props.projects.length) {
    const firstImageBlock = props.projects[0].content.body.find(
      (block) => block.component === "image-block"
    );
    ogImage = firstImageBlock.media.filename;
  }

  return (
    <StoryProvider {...props} story={story}>
      <NextSeo
        openGraph={{
          url: "https://monokel-eyewear.com/projects",
          title: "Projects – Monokel Eyewear",
          images: [
            {
              url: ogImage,
            },
          ],
        }}
      />
      <Header />

      {props?.projects.map((project, index) => {
        let imageIndex = 0;

        return (
          <Link href={"/" + project.full_slug} shallow key={index}>
            <div className="Grid Grid-projects">
              <div className="Grid-block Grid-block--full">
                <div className="Grid-blockContent">
                  <div className="Grid-projectsTitle">
                    {project?.content?.subheader}
                    <br />
                    {project.name}
                  </div>
                  <div
                    className={classNames("Grid-projectsImages", {
                      "is-multiply": project?.content?.multiply,
                    })}
                  >
                    {project?.content?.body.map((block) => {
                      if (block.component !== "image-block") {
                        return null;
                      }
                      imageIndex++;

                      if (imageIndex > 12) {
                        return null;
                      }

                      return (
                        <div
                          className={classNames("Grid-projectsImg", {
                            "Grid-projectsImg--horizontal":
                              block.width === "full",
                          })}
                          key={imageIndex}
                          style={{
                            zIndex: project?.content?.body.length - imageIndex,
                          }}
                        >
                          {imageIndex < 10 ? `0${imageIndex}` : imageIndex}
                          <StoryblokImage
                            sizes={`(min-width: 840px), 50vw`}
                            asset={block.media}
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </Link>
        );
      })}

      <Footer />
    </StoryProvider>
  );
}

export async function getStaticProps({ preview }) {
  const isWorkingInStoryblok = process.env.NODE_ENV !== "production" || preview;

  const centraRes = centraPostWithAuthAndCache(
    "https://monokel.centra.com/api/checkout/products/",
    "none",
    {
      pricelist: "all",
      market: "6",
    }
  );

  const mainMenuRes = getStoryblokStory("main-menu", {
    version: isWorkingInStoryblok ? "draft" : "published",
  });

  const projectsRes = getStoryblokStory("?starts_with=projects/", {
    version: isWorkingInStoryblok ? "draft" : "published",
  });

  const dataSourcesRes = getStoryblokDataSources();

  try {
    // eslint-disable-next-line no-var
    var [centraData, dataSources, mainMenu, projects] = await Promise.all([
      centraRes,
      dataSourcesRes,
      mainMenuRes,
      projectsRes,
    ]);
  } catch (error) {
    console.error(error);

    return {
      notFound: true,
    };
  }

  const swrFallback = centraData.products.reduce((result, p) => {
    const url = `https://monokel.centra.com/api/checkout/products/${p.product}`;
    result[url] = { product: p };

    return result;
  }, {});

  return {
    revalidate: 60,
    props: {
      dataSources,
      projects,
      mainMenu,
      swrFallback,
    },
  };
}
